export const discountedPrice = (totalPrice, discountValue) => {
    const discountAmount = totalPrice * discountValue / 100;
    const priceAFterDiscount = totalPrice - discountAmount;
    return Math.round(priceAFterDiscount)
}

export const convertDateToString = (date) => {
    const dated = new Date(date).toDateString()
    return dated
}

export const getBookingDate = () => {
    const addDays = (days) => {
        let date = new Date();
        date.setDate(date.getDate() + days);
        return date;
    }

    const newArray = Array.from({ length: 10 }, (_, i) => i + 1).map((num) => addDays(num).toDateString())
    return newArray
}

export const navigation = [
    { name: "Home", link: '/' },
    { name: "Facials", link: 'product/facial' },
    { name: "Waxing", link: 'product/waxing' },
    { name: "Threading", link: 'product/threading' },
    { name: "Hair Cut", link: 'product/haircut' },
    { name: "Makeup", link: 'product/makeup' },
    { name: "Nail Art", link: 'product/nail_art' },
    { name: "Manicure", link: 'product/manicure' },
    { name: "Saree Draping", link: 'product/saree_draping' },
    { name: "Massage & Spa", link: 'product/massage_and_spa' }
]